import React from "react";
import FloatingIcons from "../components/FloatingIcons";

function Services() {
  return (<div className="pt-16 rounded-lg shadow-lg">
     <FloatingIcons />
    <div className="pt-12 px-6 md:px-12 lg:px-20 flex flex-col lg:flex-row items-center justify-center gap-8">

    </div>
  </div>);
}

export default Services;
